import { newNotification } from "@kontextwerk/web-sdk/core/overlay/notifications"
import { mdiPlay } from "@mdi/js"
import {
  executeContactOrderStepNow,
  type ContactOrderStep,
} from "../../../../../../../../api/kehrblatt/contact-orders"
import type { ContactOrderStepActionContext, ExecuteNowStartedCallback } from "../_logic/contract"
import { blockedTargetTooltip, isOutstandingStatus } from "../_shared/_logic/action-availability"
import { isExecuteNowRefreshPending } from "../_logic/executeNowRefresh"
import type { TableRowAction } from "@kontextwerk/web-sdk/core/layout/table"
export default function buildActions(
  {
    row,
    order,
    step,
    stepId,
    caseId,
    contactOrderId,
    targetContactPointUsable,
    canExecuteNow: canExecuteNowCapability,
    onApplyStepPatch,
    onContactOrderStepUpdated,
    onExecuteNowStarted,
  }: ContactOrderStepActionContext & {
    canExecuteNow: boolean
    onExecuteNowStarted: ExecuteNowStartedCallback
  },
  state: { executing: boolean },
): TableRowAction[] {
  const canExecuteNow = Boolean(
    String(row.channel ?? "").toUpperCase() !== "LETTER" &&
    canExecuteNowCapability &&
    isOutstandingStatus(step?.status),
  )
  const executeTooltip = (() => {
    const status = String(step?.status ?? "").toUpperCase()

    if (status === "RETRY_SCHEDULED") return "Neuen Versuch jetzt starten"

    if (status === "ERROR") return "Erneut ausführen"

    return "Diesen Kontaktschritt jetzt ausführen"
  })()
  const executeStepNow = async () => {
    if (!stepId || state.executing) return

    state.executing = true
    try {
      const updatedStep = await executeContactOrderStepNow(caseId, contactOrderId, stepId, {})
      const nextStatus = isOutstandingStatus(updatedStep.status) ? "EXECUTING" : updatedStep.status
      const visibleStep = {
        ...updatedStep,
        status: nextStatus as ContactOrderStep["status"],
      }
      onContactOrderStepUpdated(order.id, visibleStep)
      onApplyStepPatch(stepId, visibleStep)

      if (isExecuteNowRefreshPending(visibleStep)) {
        onExecuteNowStarted(stepId)
      }

      newNotification({
        class: "success",
        html: "Ankündigungsschritt wurde zur Ausführung eingeplant.",
      })
    } catch (err) {
      console.error("contact_order_step_execute_failed", err)
      newNotification({
        class: "error",
        html: "Ankündigungsschritt konnte nicht gestartet werden.",
      })
    } finally {
      state.executing = false
    }
  }
  const actions: TableRowAction[] = []

  if (canExecuteNow) {
    actions.push({
      id: "action-0",
      label: targetContactPointUsable ? executeTooltip : blockedTargetTooltip,
      onClick: () => executeStepNow(),
      icon: mdiPlay,
      disabled: state.executing || !targetContactPointUsable,
      tooltip: targetContactPointUsable ? executeTooltip : blockedTargetTooltip,
    })
  }

  return actions
}
